module.exports = __webpack_public_path__ + "img/inofup.a05bee12.svg";